import React from "react"
import { useDispatch, useSelector } from "react-redux"
import CustomDateRange from "components/Atoms/CustomDateRange"
import CustomRadio from "components/Atoms/CustomRadio"
import CustomRadioGroup from "components/Atoms/CustomRadioGroup"
import DynamicSelector from "components/Molecules/DynamicSelector"
import SearchFilter, {
  SearchFilterCallout,
} from "components/Organisms/SearchFilter"
import { DEPOTS, VARIETIES } from "graphql/selector.queries.gql"
import { DEMAND_CHANGE_FILTER } from "store/demand.redux"
const DemandSearchFilter = () => {
  const filter = useSelector((state: any) => state.demands.filter)

  const dispatch = useDispatch()
  function handleChange(values) {
    dispatch({
      type: DEMAND_CHANGE_FILTER,
      payload: values,
    })
  }
  return (
    <SearchFilter
      onClear={e => handleChange({ page: 0, search: "", isLive: null })}
      getValues={values => handleChange(values)}
      value={filter}
      className="ml-3"
    >
      <SearchFilterCallout title="Demand Range">
        <CustomDateRange
          path="demandRange"
          label="Demand Date Range"
          big={false}
        />
      </SearchFilterCallout>
      <SearchFilterCallout title="Variety">
        <DynamicSelector
          formGroupProps={{
            className: "mt-3",
          }}
          searchVector={["name", "commodity.name"]}
          query={VARIETIES}
          variables={{ includeCommodity: true }}
          path="variety"
          label="Variety"
          labelElement="commodity.name"
          renderText={selectedItem => {
            if (selectedItem && selectedItem.name) {
              const { name: varietyName, commodity } = selectedItem

              return varietyName &&
                commodity &&
                commodity.name &&
                varietyName.includes(commodity.name)
                ? varietyName
                : `${commodity.name} | ${varietyName}`
            } else {
              return "Select"
            }
          }}
        />
      </SearchFilterCallout>
      <SearchFilterCallout title="Depot">
        <DynamicSelector
          formGroupProps={{
            className: "mt-3",
          }}
          query={DEPOTS}
          variables={{ includeCommodity: false }}
          path="depot"
          label="Depot"
        />
      </SearchFilterCallout>
      <SearchFilterCallout title="Live">
        <CustomRadioGroup path="isLive">
          <CustomRadio name="Live" id="live" />
          <CustomRadio name="Not Live" id="not-live" />
        </CustomRadioGroup>
      </SearchFilterCallout>
    </SearchFilter>
  )
}

export default DemandSearchFilter
